import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { FlashscanResult } from "@/types/Flashscan";
import { FlashscanRiskBreakdownLine } from "@/types/Flashscan";
import { FlashscanRiskBreakdownRow } from "@/components/FlashscanRiskBreakdownRow/FlashscanRiskBreakdownRow";
import "./FlashscanRiskBreakdown.scss";

type FlashscanRiskBreakdownProps = {
  flashscanResult: FlashscanResult;
};

export const FlashscanRiskBreakdown: React.FC<FlashscanRiskBreakdownProps> = ({
  flashscanResult,
}) => {
  const { t } = useTranslation();

  const riskLines = useMemo<FlashscanRiskBreakdownLine[]>(() => {
    return [...(flashscanResult.riskBreakdown ?? [])].sort(
      (a, b) => b.amount - a.amount,
    );
  }, [flashscanResult.riskBreakdown]);

  const max = flashscanResult.savedAmount;

  return (
    <section className="flashscan-risk-breakdown">
      <h2 className="flashscan-risk-breakdown-title">
        {t("pages.flashscan.riskBreakdown.title")}
      </h2>

      <div className="flashscan-risk-breakdown-separator" />

      <div className="flashscan-risk-breakdown-list">
        {riskLines.map((line, index) => (
          <FlashscanRiskBreakdownRow
            key={line.errorReason}
            line={line}
            position={index}
            maxAmount={max}
          />
        ))}
      </div>
    </section>
  );
};
